import { Link, useLocation } from "react-router-dom"
import BreadcrumbBlock from "../../../components/BreadcrumbBlock/BreadcrumbBlock"
import Layout from "../../../Layout"
import { Menu } from "antd"
import { MenuProps } from "antd/lib";
import { useEffect, useState } from "react";
import { getListMenu, IMenu } from "../../../api/menu/MenuApi";
import RecycleGroupCustomer from "./Component/RecycleGroupCustomer";
import useToast from "../../../hook/useToast";
import RecycleCustomerList from "./Component/RecycleCustomerList";

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}
const RecycleBin: React.FC = () => {
  const pushToast = useToast()
  const [menu, setMenu] = useState<IMenu[]>([])
  const items: MenuProps['items'] = menu.map((menuItem) => (
    getItem(menuItem.name, menuItem.menuUrl.slice(1), '',
      menuItem.childrenMenu && menuItem.childrenMenu.map((children) => (
        getItem(
          <p rel="noopener noreferrer">
            {children.name}
          </p>,
          `${children.menuUrl === 'null' || children.menuUrl === null ? '/' : children.menuUrl}`,
        )
      ))
    )
  ))
  // menu
  const gListmenu = async () => {
    const result = await getListMenu(0)
    if (result?.status) {
      setMenu(result?.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }

  useEffect(() => {
    gListmenu()
  }, [])

  const location = useLocation();
  const [current, setCurrent] = useState(location.pathname === '/customer/recyclebin'
    ? '/customer/recyclecustomerlist'
    : "")
  const [checkCurrent, setCheckCurrent] = useState(current)


  const parents = ['customer']
  const [currentParent, setCurrentParent] = useState(
    parents.find(item => current.includes(item)) || "customer"
  )

  useEffect(() => {
    if (location) {
      if (checkCurrent !== location.pathname) {
        setCheckCurrent(checkCurrent)
      }
      const parents = ['customer']
      const parentName = parents.find(item => checkCurrent.includes(item)) || ''
      setCurrentParent(parentName)
    }
  }, [current])

  const onClick: MenuProps['onClick'] = (e) => {
    setCheckCurrent(e.key)
  };
  return (
    <Layout>
      <BreadcrumbBlock
        items={[
          { title: <Link to="/">THACO AUTO CRM</Link>, },
          { title: 'Khách hàng', },
          { title: 'Thùng rác', },
        ]}
        title='Thùng rác'
        className='gutter-block-end'
      />
      <div className="w-full d-flex gap-6 h-full">
        <div className="w-20-percent d-flex flex-column gap-4">
          <span className="text-20-px fw-500 font-medium">Tính năng</span>
          <div className="ct-menu-cycle">
            <Menu
              onClick={onClick}
              defaultSelectedKeys={[checkCurrent]}
              defaultOpenKeys={[currentParent]}
              mode="inline"
              items={items}
              className='rs-scrollbar'
            />
          </div>
        </div>

        <div className="w-80-percent">
          {
            checkCurrent === "/customer/recyclecustomerlist" && <RecycleCustomerList />
          }
          {
            checkCurrent === "/customer/recyclegroupcustomer" && <RecycleGroupCustomer />
          }
        </div>
      </div>
    </Layout>
  )
}
export default RecycleBin
